import type { CSSProperties, ReactNode } from 'react';

import type { PageOrientation } from 'components/editor/shared/gridConfig';
import { PreviewFooter } from './footer';
import { PreviewHeader } from './header';
import { PreviewMainGrid } from './mainGrid';

import './preview.styles.less';

interface Props {
  header?: ReactNode;
  leftAside?: ReactNode;
  main: ReactNode;
  footer?: ReactNode;
  banner?: ReactNode;
  canvasWidth?: number;
  canvasMinHeight?: number;
  orientation?: PageOrientation;
  contentId: string;
}

export const PreviewGrid = ({ header, leftAside, main, footer, banner, canvasWidth, canvasMinHeight, orientation, contentId }: Props) => {
  const canvasVars =
    canvasWidth !== undefined
      ? ({ '--canvas-width': `${canvasWidth}px`, '--canvas-min-height': `${canvasMinHeight}px` } as CSSProperties)
      : undefined;
  return (
    <div className={`preview${orientation === 'landscape' ? ' preview--landscape' : ''}`} style={canvasVars}>
      {header && <PreviewHeader>{header}</PreviewHeader>}
      {banner}
      {leftAside && (
        <div
          className="preview__leftAside"
          data-testid="preview-left-aside"
          style={{
            position: 'fixed',
            left: 0,
            top: '144px',
            width: '240px',
            maxHeight: 'calc(100vh - 144px)',
            overflowY: 'auto',
            backgroundColor: 'transparent',
          }}
        >
          {leftAside}
        </div>
      )}
      <PreviewMainGrid hasLeftAside={!!leftAside} contentId={contentId}>
        {main}
      </PreviewMainGrid>
      {footer && <PreviewFooter>{footer}</PreviewFooter>}
    </div>
  );
};
